import React,{Component} from 'react'

import {
  CardContent,
  Typography,
} from 'material-ui'

import LaunchIcon from 'material-ui-icons/Launch'
import KeyboardArrowRightIcon from 'material-ui-icons/KeyboardArrowRight'

import {
  LightGray,
  Black,
} from '../helper/consts'

const style = {
  addressLinkBar:{
    transition:'color 0.3s ease',
    color:LightGray,
  },
  addressLinkBarCardContent:{
    display: 'flex',
    alignItems: 'center',
  },
  addressLinkBarText:{
    marginLeft:'24px',
    color:Black,
  },
  actionSpace:{
    flex: '1 1 auto',
  },
}

export default class AddressLinkBar extends Component{
  render(){
    const {location} = this.props;
    return (
      <a style={style.addressLinkBar} className='blackOnHover' target='_blank' href={`https://www.google.com/maps/search/${location}`}>
        <CardContent style={style.addressLinkBarCardContent}>
          <LaunchIcon />
          <Typography style={style.addressLinkBarText} align="left" color="inherit" type="body1" >{location}</Typography>
          <div style={style.actionSpace} />
          <KeyboardArrowRightIcon />
        </CardContent>
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AddressLinkBar.js